<template lang="html">
  <transition name="fade">
    <div v-show="show" class="tips" :class="color">
      {{ text }}
      <i class="glyphicon glyphicon-remove" @click="show = false"></i>
    </div>
  </transition>
</template>

<script>
import bus from '../../../bus/bus.js'

export default {
  data () {
    return {
      show: false,
      text: undefined,
      color: 'primary',
      second: 3000
    }
  },
  mounted () {
    bus.$on('show-tips', (text, color, second) => {
      this.$set(this, 'text', text)
      if (color) { this.$set(this, 'color', color) }
      if (second) { this.$set(this, 'second', color) }
      this.$set(this, 'show', true)
      this.showTime()
    })
  },
  methods: {
    showTime () {
      setTimeout(() => {
        this.$set(this, 'show', false)
      }, this.second)
    }
  }
}
</script>

<style lang="less">
  .tips {
    margin: 15px auto;
    position: fixed;
    top: 30%;
    // left: 0;
    // right: 0;
    // display: inline;
    // max-width: 500px;
    min-width: 180px;
    transform: translateX(-50%);
    left: 50%;
    right: 50%;
    height: 30px;
    line-height: 30px;
    color: #fff;
    text-align: center;
    z-index: 1000;
    padding: 5px 10px;
    letter-spacing: 1px;
    i {
      color: #fff;
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%);
      margin: auto;
      cursor: pointer;
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .4s;
  }
  .fade-enter, .fade-leave-active {
    opacity: 0;
  }
  .primary {
    background-color: #4285f4;
  }
  .warning {
    background-color: #fe7849;
  }
  .success {
    background-color: #8ebf4a;
  }
  .danger {
    background-color: #d9534f
  }
</style>



// WEBPACK FOOTER //
// tips.vue?b09fcdf0